function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RestaurantsListing.css';
import React, { useState } from 'react';
import { canUseDOM, get, getDictionaryItem, replaceUrlPluses } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacetsWithoutPlusReplacement } from './index';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
import { RestaurantsCard } from '../atoms/RestaurantsCard/RestaurantsCard';
import { checkJssError } from '../../utils/checkJssError';
import InteractiveMapModal from '../atoms/InteractiveMapModal/InteractiveMapModal';
import { splitter } from '../Listing';
import { getInteractiveModalMapConfig } from '../atoms/InteractiveMapModal/utils/getInteractiveModalMapConfig';
const getFacetNamesValue = filterData => {
  if (filterData) {
    return filterData.values.map(filter => {
      const item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      const item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      return item1 || item2;
    });
  } else {
    return [];
  }
};
const createFilterState = (filtersList, location) => {
  const qsValues = canUseDOM ? qsToObject(location.search) : {};
  const state = {};
  if (filtersList && filtersList.length) {
    filtersList.forEach(filterItem => {
      const fieldName = filterItem.name;
      const fieldTitle = get(filterItem, 'title.jss.value') || filterItem.name;
      const facetName = get(filterItem, 'fieldNameItem.item.fieldName.value');
      let listOfTags = [];
      if (filterItem.tagsToDisplay && filterItem.tagsToDisplay.values && filterItem.tagsToDisplay.values.length) {
        listOfTags = filterItem.tagsToDisplay.values.map(tag => get(tag, 'title.value') || get(tag, 'title.name'));
      }
      const preselectedFromQS = qsValues[facetName] ? qsValues[facetName].split(splitter).map(value => replaceUrlPluses(value)).filter(value => listOfTags.includes(value)) : [];
      const preselectedNoDublicates = [...new Set([...preselectedFromQS])];
      state[fieldName] = {
        title: fieldTitle,
        facetName: facetName,
        value: preselectedNoDublicates || []
      };
    });
  }
  return state;
};
export const SORT_QUERY_NAME = 'sortBy';
export const TEXT_SEARCH_FACET_NAME = 'title';
const getDefaultSearchValue = location => canUseDOM ? replaceUrlPluses(qsToObject(location.search)[TEXT_SEARCH_FACET_NAME]) || '' : '';
const getDefaultSortValue = location => canUseDOM ? qsToObject(location.search)[SORT_QUERY_NAME] || '' : '';
const RestaurantsListingComponent = _ref => {
  let {
    fields,
    params
  } = _ref;
  const sitecoreContext = useSitecoreContext();
  const location = useLocation();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const algoliaSettings = {
    key: get(sitecoreContext, 'configuration.algolia.algoliaApiKey'),
    id: get(sitecoreContext, 'configuration.algolia.algoliaApplicationId'),
    fullTextSearchIndex: get(sitecoreContext, 'configuration.algolia.fullTextSearchIndex')
  };
  const searchIndexParams = get(params, 'SearchIndex', '');
  const fieldsData = get(fields, 'data', {});
  const messageSearchResultEmpty = get(fieldsData, 'contextItem.messageSearchResultEmpty.value', '');
  const typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  const filterData = get(fields, 'data.listingConfiguration.filters') || [];
  const isTagPage = get(fields, 'data.listingConfiguration.isTagPage.jss.value');
  const filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  const pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value'));
  const dictionary = get(fields, 'data.dictionary');
  const loadMoreText = getDictionaryItem(dictionary, 'LoadMore');
  const viewedNofMLabel = `${getDictionaryItem(dictionary, 'viewedAmount')}`.replace("{x}", "{#loadedHits#}").replace("{y}", "{#nbHits#}");
  const emptySearchText = getDictionaryItem(dictionary, 'NoResultFound') || '';
  const [result, setResult] = React.useState();
  const [facets, setFacets] = React.useState({});
  const [hits, setHits] = React.useState([]);
  const [page, setpage] = React.useState(0);
  const [firstRendering, setFirstRendering] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [buttonPressed, setButtonPressed] = React.useState(false);
  const [searchTextValue, setSearchTextValue] = useState(() => getDefaultSearchValue(location));
  const [sortingValue, setSortingValue] = useState(() => getDefaultSortValue(location));
  const [resetFilter, setResetFilter] = React.useState(false);
  const [resetAllFilters, setResetAllFilters] = React.useState(false);
  const [setFilters, applySetFilters] = React.useState(false);
  const [currentTypes, applycurrentTypes] = React.useState([]);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const isFirstLoadWithoutFacets = React.useRef(false);
  const mapConfigurationЫSource = get(fields, 'data.listingConfiguration.mapConfiguration');
  const mapConfiguration = mapConfigurationЫSource ? mapConfigurationЫSource[0] : [];
  const mapModalTitle = get(mapConfiguration, 'title.jss.value') || '';
  const mapModalContentType = get(fields, 'data.listingConfiguration.contentType.types[0].template.targetItem.value') || '';
  const mapModalDefaultMapZoom = Number(get(mapConfiguration, 'defaultMapZoom.jss.value')) || 10;
  const mapModalCentreMapLatitude = Number(get(mapConfiguration, 'centreMapLatitude.jss.value')) || 25.2048493;
  const mapModalCentreMapLongitude = Number(get(mapConfiguration, 'centreMapLongitude.jss.value')) || 55.2707828;
  const mapModalColor = get(mapConfiguration, 'colourTheme.item.backgroundColor.jss.value') || 'var(--main-color)';
  const withMapModalView = getInteractiveModalMapConfig(mapConfiguration);
  const maxPageSize = 1000;
  const mapDictionary = get(fields, 'data.mapDictionary');
  const [allHits, setAllHits] = React.useState([]);
  const [filterState, setFilterState] = useState(() => createFilterState(filterData.values, location));
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (let key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  let facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, filterData);
  const concatFilters = (() => {
    return facetFilters.reduce((acc, filter) => {
      const validFilter = filter.reduce((filterAcc, filterEl) => {
        filterAcc.push(filterEl);
        return filterAcc;
      }, []);
      acc = acc.concat(validFilter);
      return acc;
    }, []);
  })();
  const concatFiltersForFiltersFiled = (() => {
    return facetFilters.reduce((acc, filter) => {
      const validFilter = filter.reduce((filterAcc, filterEl) => {
        const index = filterEl.indexOf(':');
        const afterColon = filterEl.slice(index + 1).trim();
        if (!Boolean(afterColon.length > 0)) {
          return filterAcc;
        }
        filterAcc.push(filterEl.replace(/:([^:]*)$/, ":'$1'"));
        return filterAcc;
      }, []);
      acc = acc.concat(validFilter);
      return acc;
    }, []);
  })();
  let prevFacetFilters = usePrevious(facetFilters);
  const prevPage = usePrevious(page);
  React.useEffect(() => {
    const algoliaIndexes = sortingValue ? `${get(params, 'SearchIndex')}_${sortingValue}` : get(params, 'SearchIndex');
    let types = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:${value}`;
    });
    let typesForFiltersFiled = typeArray.map(type => {
      let value = type && type.template.targetItem.value;
      return `type:'${value}'`;
    });
    applycurrentTypes(types);
    const facetNames = getFacetNamesValue(filterData);
    const concatFiltersForFiltersFiledFormatConditions = concatFiltersForFiltersFiled.map(filed => filed.split(':')).reduce((acc, _ref2, index, array) => {
      let [key, value] = _ref2;
      const separator = index < array.length - 1 ? array[index][0] === array[index + 1][0] ? ' OR ' : ' AND ' : '';
      return acc + `${key}:${value}` + separator;
    }, '');
    const getFilters = () => {
      if (concatFiltersForFiltersFiled.length) {
        return `${typesForFiltersFiled} AND ${concatFiltersForFiltersFiledFormatConditions}`;
      }
      return `${typesForFiltersFiled}`;
    };
    const isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == 'type:Event';
    const itemFilters = {
      query: searchTextValue,
      facets: [...facetNames],
      filters: getFilters(),
      hitsPerPage: isLoadedFeatureItem ? pagesize + 1 : pagesize,
      page: page
    };
    const allItemFilters = {
      query: searchTextValue,
      facets: [...facetNames],
      facetFilters: [...types, ...concatFilters],
      hitsPerPage: maxPageSize,
      page: 0
    };
    const listingRequestAllItems = () => {
      setLoading(true);
      let promisesQueue = [];
      let finalResponse = [];
      let pageNumber = 1;
      getListing(algoliaIndexes, allItemFilters, algoliaSettings).then(response => {
        if (response.hits) {
          applySetFilters(false);
          finalResponse = [...response.hits];
          finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
          setAllHits(finalResponse);

          // nbPages - max available items per page
          if (pageNumber < response.nbPages) {
            // create array of promisses
            for (let i = 1; i < response.nbPages; i++) {
              const itemFilterCopy = _objectSpread({}, allItemFilters);
              itemFilterCopy.page = i;
              promisesQueue.push(itemFilterCopy);
            }
            if (promisesQueue.length) {
              Promise.all(promisesQueue.map(item => {
                getListing(algoliaIndexes, item, algoliaSettings).then(responses => {
                  // summarize all the hits by all request
                  finalResponse = [...finalResponse, ...responses.hits];
                  finalResponse = finalResponse.filter(el => el._geoloc && el.objectID);
                }).then(() => {
                  setAllHits(finalResponse);
                  setTimeout(() => setLoading(false), 1000);
                }).catch(function (error) {
                  console.log(error);
                });
              }));
            }
          }
        }
      }).then(() => {
        setTimeout(() => setLoading(false), 1000);
        setResetAllFilters(false);
      });
    };
    const listingRequest = () => {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters, algoliaSettings).then(response => {
        setFacets(response.facets);
        setResult(response);
        applySetFilters(false);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            const resultsBlocks = document.querySelectorAll('.results');
            if (resultsBlocks.length) {
              const lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              const focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                const lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = () => {};
          }
        }, 100);
        setLoading(false);
        setFirstRendering(false);
        setResetAllFilters(false);
      });
    };
    if (resetAllFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else if (setFilters) {
      listingRequest();
      if (withMapModalView) {
        listingRequestAllItems();
      }
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
          if (withMapModalView) {
            listingRequestAllItems();
          }
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters]);
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const loadMoreAnalyticsClick = text => {
    tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['LoadMoreAnalytics'], params), text);
  };
  const loadMore = () => {
    if (canUseDOM) {
      window.onscroll = () => {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    setpage(prevState => prevState + 1);
    loadMoreAnalyticsClick(loadMoreText);
  };
  if (isNil(fields) || isNil(fields.data) || isNil(fields.data.listingConfiguration)) {
    console.warn('RestaurantsListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[RestaurantsListing component is empty: please provide datasource]");
    }
    return null;
  }
  const nbHits = result ? result.nbHits : 0;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    fields: fields,
    setpage: setpage,
    setHits: setHits,
    facets: facets,
    applySetFilters: applySetFilters,
    rtl: rtl,
    searchTextValue: searchTextValue,
    setSearchTextValue: setSearchTextValue,
    sortingValue: sortingValue,
    setSortingValue: setSortingValue,
    nbHits: nbHits,
    filterState: filterState,
    setFilterState: newValue => setFilterState(newValue)
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement(React.Fragment, null, currentTypes.map((type, index) => {
    if (type === 'type:Restaurant' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Restaurant')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row restaurantsListingRowGap"
      }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
        className: "empty-results",
        dangerouslySetInnerHTML: {
          __html: emptySearchText
        }
      }), hits && hits.map((hit, index) => {
        if (hit.type.indexOf('Restaurant') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4",
            style: {
              display: "flex"
            },
            key: index
          }, /*#__PURE__*/React.createElement(RestaurantsCard, {
            analyticsCallback: eventsAnalytics,
            item: hit,
            params: params,
            reviews: getDictionaryItem(dictionary, 'reviews') || '',
            rtl: rtl,
            textToHighlight: searchTextValue
          }));
        }
      }))))));
    }
  }), !loading && !hits.length && /*#__PURE__*/React.createElement("div", {
    className: "load-more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "message-search-result-empty"
  }, messageSearchResultEmpty)), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: loadMoreText,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel
  }))), withMapModalView && /*#__PURE__*/React.createElement(InteractiveMapModal, {
    loading: loading,
    params: params,
    hits: allHits,
    mainHitsPerPage: `${pagesize}`,
    mainTitle: mapModalTitle,
    contentType: mapModalContentType,
    defaultMapZoom: mapModalDefaultMapZoom,
    centreMapLatitude: mapModalCentreMapLatitude,
    centreMapLongitude: mapModalCentreMapLongitude,
    mapModalColor: mapModalColor,
    dictionary: mapDictionary,
    eventsAnalytics: eventsAnalytics,
    filtersComponent: filterValue && filterValue.length >= 1 ? /*#__PURE__*/React.createElement(Filters, {
      params: params,
      fields: fields,
      setpage: setpage,
      setHits: setHits,
      facets: facets,
      applySetFilters: applySetFilters,
      rtl: rtl,
      searchTextValue: searchTextValue,
      setSearchTextValue: setSearchTextValue,
      sortingValue: sortingValue,
      setSortingValue: setSortingValue,
      nbHits: nbHits,
      withMapModalView: true,
      filterState: filterState,
      setFilterState: newValue => setFilterState(newValue)
    }) : /*#__PURE__*/React.createElement(React.Fragment, null)
  })));
};
const RestaurantsListing = props => checkJssError(props, RestaurantsListingComponent);
const StyledWrapper = _ref3 => {
  let {
    children,
    rtl
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", {
    className: `${poiStyle} ${loadMoreButtonStylesLtr} ${commonStyles}
     ${rtl ? stylesRTL : stylesLTR} `
  }, children);
};
export const commonStyles = "c1wh5elx";
export const poiStyle = "pkdxjib";
export const stylesLTR = "skagn3h";
export const stylesRTL = "s1y0cr32";
export default RestaurantsListing;